import(/* webpackMode: "eager" */ "/vercel/path0/app/articles/error.tsx");
